export default function IdentitySection() {
  return (
    <section className="relative w-full bg-background-100 py-20 md:py-28 px-4 md:px-6">
      <div className="w-full max-w-[1100px] mx-auto">
        <p className="text-xs md:text-sm font-label uppercase tracking-[0.2em] text-foreground-400 mb-6 font-medium">
          Engineering Philosophy
        </p>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-body font-light text-foreground-900 leading-tight mb-5 max-w-[700px]">
          Building systems{' '}
          <span className="font-heading italic text-primary-500">that</span>
          <br />
          last for decades
        </h2>

        <p className="text-base md:text-lg text-foreground-500 font-body font-light max-w-[650px] mb-16 md:mb-20 leading-relaxed">
          We are a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. Our approach combines clean architecture, performance optimization, and user-centered design to create systems that remain stable and maintainable over time.
        </p>

        <div className="flex flex-col md:flex-row gap-5">
          <div className="flex-1 bg-accent-500 rounded-2xl p-8 md:p-10 relative overflow-hidden">
            <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center mb-8">
              <i className="ri-arrow-right-up-line text-background-50 text-xl"></i>
            </div>

            <p className="font-heading text-7xl md:text-8xl text-background-50 mb-6 leading-none">
              98<span className="text-4xl md:text-5xl align-top ml-1">%</span>
            </p>

            <p className="text-background-50/90 text-base md:text-lg font-body leading-relaxed mb-8">
              Of engineering effort dedicated to architectural planning, rigorous testing, and system design before a single line of production code is written.
            </p>

            <p className="font-heading italic text-background-50/70 text-sm">
              Precision from the start.
            </p>
          </div>

          <div className="flex-1 bg-secondary-500 rounded-2xl p-8 md:p-10 relative overflow-hidden">
            <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center mb-8">
              <i className="ri-arrow-right-up-line text-background-50 text-xl"></i>
            </div>

            <p className="font-heading text-7xl md:text-8xl text-background-50 mb-6 leading-none">
              100<span className="text-4xl md:text-5xl align-top ml-1">%</span>
            </p>

            <p className="text-background-50/90 text-base md:text-lg font-body leading-relaxed mb-8">
              Commitment to long-term technical quality through clean architecture, performance optimization, and continuous refinement of engineering practices. Every system is built with adaptability and maintainability at its core.
            </p>

            <p className="font-heading italic text-background-50/70 text-sm">
              Built to evolve, engineered to endure.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}